import WhatsappIcon from '@mui/icons-material/WhatsApp';
import { Button, Grid } from '@mui/material';
import { FC } from 'react';
import { Page } from '~/components/ui/page';
import { Body1, Title } from '~/components/ui/typography';

interface IdentityCheckSuccessScreenProps {
  whatsappNumber: string | null;
}

/**
 * The validation always ends with the customer going back to the WhatsApp
 * conversation they came from, so the way back to it is always offered.
 */
export const IdentityCheckSuccessScreen: FC<IdentityCheckSuccessScreenProps> = ({ whatsappNumber }) => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${whatsappNumber}`, '_blank');
  };

  return (
    <Page innerWrapperSx={{ width: { xs: '100%', sm: '800px' } }}>
      <Title>Identidade confirmada!</Title>
      <img style={{ marginTop: '30px' }} src="/identity-confirmed.svg" />
      <Body1>
        Tudo certo! Confirmamos que é você. Agora é só voltar para a conversa no WhatsApp e continuar de onde parou.
      </Body1>
      <Grid container spacing={2} justifyContent="center">
        {whatsappNumber && (
          <Grid item xs={12} sm={6}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<WhatsappIcon />}
              onClick={handleWhatsApp}
              sx={{ fontWeight: 'bold', textTransform: 'none' }}
            >
              Voltar para WhatsApp
            </Button>
          </Grid>
        )}
      </Grid>
    </Page>
  );
};
